import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from './const';
import Select from 'react-select';
import './toaststyle.css';
import Swal from 'sweetalert2';
import { fill } from 'lodash';


const validateField = (name, value) => {
    switch (name) {
        case 'ptnctno':
            if (!value || value.trim() === '') return "Partner contact number is required.";
            if (!/^\d{10}$/.test(value)) return "Contact number must be 10 digits.";
            return "";
        case 'ptnemail':
            if (!value || value.trim() === '') return "Partner email is required.";
            if (!/^[\w-.]+@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)) return "Please enter a valid email address.";
            return "";
        case 'partner_desc':
            if (!value || value.trim() === '') return "Partner's scope and objective is required.";
            return "";
        case 'sona_desc':
            if (!value || value.trim() === '') return "Sona's scope and objective is required.";
            return "";
        case 'mou_type':
            if (!value || value.trim() === '') return "MOU type is required.";
            return "";
        case 'document':
            if (!value || value.trim() === '') return "MOU Document is required.";
            return "";    
        case 'dateOfEnd':
            if (!value) return "Date of end is required.";
            return "";
        default:
            return "";
    }
};

const validateForm = (fields) => {
    const errors = {};
    let { title, dos, ptnorg, ptnctno, ptnemail, sonaptns, partner_desc, sona_desc, mou_type, dateOfEnd } = fields;
    title = title.trim();
    dos = dos.trim();
    ptnorg = ptnorg.trim();
    ptnctno = ptnctno.trim();
    ptnemail = ptnemail.trim();
    sonaptns = sonaptns.trim();
    partner_desc = partner_desc.trim();
    sona_desc = sona_desc.trim();
    mou_type = mou_type.trim();
    
    if (!title) errors.title = "Title is required.";
    if (!dos) errors.dos = "Date of signing is required.";
    if (!ptnorg) errors.ptnorg = "Partner organization name is required.";
    if (!ptnctno) errors.ptnctno = "Partner contact number is required.";
    if (!ptnemail) errors.ptnemail = "Partner email is required.";
    if (!sonaptns) errors.sonaptns = "Sona partner names are required.";
    if (!partner_desc) errors.partner_desc = "Partner's scope and objective is required.";
    if (!sona_desc) errors.sona_desc = "Sona's scope and objective is required.";
    if (!mou_type) errors.mou_type = "MOU type is required.";
    if (!dateOfEnd) errors.dateOfEnd = "Date of end is required.";
    if(!document) errors.document = "MOU Document is required"

    if (fields.dos && fields.dateOfEnd) {
        const startDate = new Date(fields.dos);
        const endDate = new Date(fields.dateOfEnd);
        if (endDate < startDate) {
            errors.dateOfEnd = "Date of end must be greater than date of signing.";
        }
    }

    return errors;
};

const AddMou = () => {

    const { mouId } = useParams(); // Get mouId from URL parameters
    const history = useHistory();

    console.log(useParams());
    console.log(API_BASE_URL);
    
    const [fields, setFields] = useState({
        title: "",
        dos: "",
        ptnorg: "",
        ptnctno: "",
        ptnemail: "",
        sonaptns: "",
        partner_desc: "",
        sona_desc: "",
        mou_type: "",
        dateOfEnd: ""
    });
    const [errors, setErrors] = useState({});
    const [lastMouId, setLastMouId] = useState(null);
    const [options, setOptions] = useState([]);
    const [mouTypeOptions, setMouTypeOptions] = useState([]);
    const [document, setDocument] = useState('');
    const [editMode, setEditMode] = useState(false);    
    const [filename, setFilename] = useState('');

    useEffect(() => {
        const fetchLastMouId = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/mous/last-mouid`);
                setLastMouId(response.data || 'MOU0000');
            } catch (error) {
                console.error('Error fetching last MOU ID:', error);
            }
        };

        const fetchUsers = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users`);
                const users = response.data || []; 
        
                // Map users to the format needed for Select
                const res = users.length > 0 
                    ? users.map(obj => ({
                        value: obj.userId, 
                        label: obj.username
                    })) 
                    : [{ value: "data-not-found", label: "Data not found" }];
        
                setOptions(res);
            } catch (error) {
                console.error('Error fetching users:', error);
                setErrors(prevErrors => ({ ...prevErrors, sonaptns: "Oops, try again" }));
            }
        };
         
        const mouTypeOptions = [
            { value: 'International organization', label: 'INTERNATIONAL ORGANIZATION' },
            { value: 'National organization', label: 'NATIONAL ORGANIZATION' },
            { value: 'International institute', label: 'INTERNATIONAL INSTITUTE' },
            { value: 'National institute', label: 'NATIONAL INSTITUTE' },
        ];
        setMouTypeOptions(mouTypeOptions);

        fetchLastMouId();
        fetchUsers();
    }, []);

    useEffect(() => {
        const fetchMouDetails = async () => {
            if (mouId) {
                try {
                    setEditMode(true); // Set editMode to true
                    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mous/${mouId}`);
                    const mouData = response.data;

                    // Format dateOfSign and end
                    const formattedDateOfSign = new Date(mouData.dateOfSign).toISOString().split("T")[0];
                    const formattedDateOfEnd = new Date(mouData.dateOfEnd).toISOString().split("T")[0];

                    setFields({
                        title: mouData.title,
                        dos: formattedDateOfSign,
                        ptnorg: mouData.ptnOrg,
                        ptnctno: mouData.ptnCntNo,
                        ptnemail: mouData.ptnEmail,
                        sonaptns: mouData.sonaPartners,
                        partner_desc: mouData.partner_desc,
                        sona_desc: mouData.sona_desc,
                        mou_type: mouData.mou_type,
                        dateOfEnd: formattedDateOfEnd,
                    });
                    setDocument(mouData.document);
                } catch (error) {
                    console.error("Error fetching MOU details:", error);
                    toast.error("Error fetching MOU details. Please try again.", {
                        className: "toast-error",
                    });
                }
            }
        };

        fetchMouDetails();
    }, [mouId]);

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setFields(prevFields => ({ ...prevFields, [name]: value }));

        const error = validateField(name, value);
        setErrors(prevErrors => ({ ...prevErrors, [name]: error }));

        if (name === 'dos') {
            if (fields.dateOfEnd && new Date(value) >= new Date(fields.dateOfEnd)) {
                setErrors(prevErrors => ({ ...prevErrors, dateOfEnd: "Date of end must be greater than date of signing." }));
            } else {
                setErrors(prevErrors => ({ ...prevErrors, dateOfEnd: "" }));
            }
        } else if (name === 'dateOfEnd') {
            if (new Date(value) <= new Date(fields.dos)) {
                setErrors(prevErrors => ({ ...prevErrors, dateOfEnd: "Date of end must be greater than date of signing." }));
            } else {  
                setErrors(prevErrors => ({ ...prevErrors, dateOfEnd: "" }));
            }
        }
    };

    const handleSelectChange = (selectedOption, actionMeta) => {
        const { name } = actionMeta;
        if (name === 'sonaptns') {
            const values = selectedOption ? selectedOption.map(option => option.value).join(', ') : '';
            setFields(prevFields => ({ ...prevFields, sonaptns: values }));
        } else if (name === 'mou_type') {
            const value = selectedOption ? selectedOption.value : '';
            setFields(prevFields => ({ ...prevFields, mou_type: value }));
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        
        // Check if the file is valid (PDF, DOC, DOCX)
        if (file && !/\.(pdf|doc|docx)$/i.test(file.name)) {
            toast.error("Invalid file type. Please upload a PDF, DOC, or DOCX", {
                className: 'toast-error',
            });
            return;
        }
    
        // Use FileReader to convert the file to a base64 string
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result.replace(/^data:.+;base64,/, '');
            setDocument(base64String);
        };
    
        // Remove file extension and set the filename
        const filenameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");  // Regex to remove file extension
        setFilename(filenameWithoutExtension);
    
        // Start reading the file as Base64
        if (file) {
            reader.readAsDataURL(file);
        }
    };
    

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        const formErrors = validateForm(fields);
        setErrors(formErrors);

        if (Object.keys(formErrors).length > 0) return;

        try {
            const dateParts = fields.dos.split("-");
            const webserviceDateTime = `${dateParts[0]}-${dateParts[1]}-${dateParts[2]} 10:00`;


            const mouData = {
                title: fields.title,
                dateOfSign: webserviceDateTime,
                ptnOrg: fields.ptnorg,
                ptnCntNo: fields.ptnctno,
                ptnEmail: fields.ptnemail,
                sonaPartners: fields.sonaptns,
                partner_desc: fields.partner_desc,
                sona_desc: fields.sona_desc,
                mou_type: fields.mou_type,
                dateOfEnd: `${fields.dateOfEnd} 00:00`,
                document,
                filename
            };

            if (editMode) {
                // Update existing MOU
                console.log(mouData);
                await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/mous/secure/${mouId}`, mouData);
                            Swal.fire("Updated!", "MOU has been updated.", "success");
            } else {
                // Create new MOU
                const numericPart = parseInt(lastMouId.slice(3)) + 1;
                const newMouId = `MOU${numericPart.toString().padStart(4, "0")}`;
                mouData.mouId = newMouId;
                console.log(mouData);
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/mous/secure`, mouData);
                Swal.fire("Created!", "MOU Signed.", "success");
                setLastMouId(newMouId);
            }

            // Reset form fields and redirect to MOU list
            setFields({
                title: "",
                dos: "",
                ptnorg: "",
                ptnctno: "",
                ptnemail: "",
                sonaptns: "",
                partner_desc: "",
                sona_desc: "",
                mou_type: "",
                dateOfEnd: "",
            });
            setDocument("");
            setFilename("");
            setErrors({});
            setTimeout(() => {
                window.history.back();

            }, 1300);
        } catch (error) {
            toast.error("Error saving MOU. Please try again.", {
                className: "toast-error",
            });
        }
    };

    return (
        <div className="p-2 bg-light">
            <ToastContainer className='me-2' />
            <div className="row justify-content-center m-1">
                <div className="col-lg-12 col-md-12 border rounded p-4 bg-white">
                    <h2 className="text-center mb-4">MOU FORM</h2>
                    <form onSubmit={handleOnSubmit}>
                        <div className="row mb-4">
                            <div className="col-md-6">
                                <label htmlFor="title" className="form-label">Title <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                                <input type="text" name="title" value={fields.title} onChange={handleOnChange} className="form-control" />
                                {errors.title && <small className="text-danger">{errors.title}</small>}
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="dos" className="form-label">Date of Signing <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                                <input type="date" name="dos" value={fields.dos} onChange={handleOnChange} className="form-control" />
                                {errors.dos && <small className="text-danger">{errors.dos}</small>}
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="dateOfEnd" className="form-label">Date of Ending <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                                <input type="date" name="dateOfEnd" value={fields.dateOfEnd} onChange={handleOnChange} className="form-control" />
                                {errors.dateOfEnd && <small className="text-danger">{errors.dateOfEnd}</small>}
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-4">
                                <label htmlFor="ptnorg" className="form-label">Partner Organization <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                                <input type="text" name="ptnorg" value={fields.ptnorg} onChange={handleOnChange} className="form-control" />
                                {errors.ptnorg && <small className="text-danger">{errors.ptnorg}</small>}
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="ptnctno" className="form-label">Partner Contact No.</label>
                                <input type="number" name="ptnctno" value={fields.ptnctno} onChange={handleOnChange} className="form-control" />
                                {errors.ptnctno && <small className="text-danger">{errors.ptnctno}</small>}
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="ptnemail" className="form-label">Partner Email <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                                <input type="email" name="ptnemail" value={fields.ptnemail} onChange={handleOnChange} className="form-control" />
                                {errors.ptnemail && <small className="text-danger">{errors.ptnemail}</small>}
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-6">
                                <label htmlFor="sonaptns" className="form-label">Sona Partners <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                                <Select
                                    isMulti
                                    options={options}
                                    name="sonaptns"
                                    className="basic-multi-select"
                                    placeholder="select sona partners"
                                    onChange={handleSelectChange}
                                    value={options.filter(option => fields.sonaptns.split(', ').includes(option.value))} // Set selected values
                                />
                                {errors.sonaptns && <small className="text-danger">{errors.sonaptns}</small>}
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="mou_type" className="form-label">MOU Type <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                                <Select
    options={mouTypeOptions}
    name="mou_type"
    className="basic-single"
    placeholder="Select MOU type"
    onChange={handleSelectChange}
    value={mouTypeOptions.find(option => option.value === fields.mou_type)} // Ensure the correct value is selected
/>

                                {errors.mou_type && <small className="text-danger">{errors.mou_type}</small>}
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-6">
                                <label htmlFor="partner_desc" className="form-label">Partner's Scope and Objective <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                                <textarea name="partner_desc" value={fields.partner_desc} onChange={handleOnChange} className="form-control" rows="6"></textarea>
                                {errors.partner_desc && <small className="text-danger">{errors.partner_desc}</small>}
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="sona_desc" className="form-label">Sona's Scope and Objective <span style={{ color: 'red', fontSize: '20px',marginLeft:"2px" }}>*</span></label>
                                <textarea name="sona_desc" value={fields.sona_desc} onChange={handleOnChange} className="form-control" rows="6"></textarea>
                                {errors.sona_desc && <small className="text-danger">{errors.sona_desc}</small>}
                            </div>
                        </div>
                        <div className="mb-4">
    <label htmlFor="filename" className="form-label">Document Name <span style={{ color: 'red', fontSize: '20px', marginLeft: "2px" }}>*</span></label>
    <input
        type="text"
        name="filename"
        value={filename}
        onChange={(e) => setFilename(e.target.value)} 
        className="form-control"
        placeholder="Enter document name"
    />
    {errors.filename && <small className="text-danger">{errors.filename}</small>}
</div>
                        <div className="mb-4">
                            <label htmlFor="document" className="form-label">Upload Document (PDF)</label>
                            <input type="file" onChange={handleFileChange} className="form-control" />
                            {errors.document && <small className="text-danger">{errors.document}</small>}
                        </div>
                        <button type="submit" className="btn btn-primary">{editMode ? "Update MOU" : "ADD MOU"}</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddMou;
